import React, { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";
import { Row, Col, Select } from "antd";
import ButtonOutlineTwo from "modules/Common/Components/ButtonOutlineTwo";
import ButtonSmall from "modules/Common/Components/ButtonSmall";
import Message from "modules/Common/Components/Message";
import ContactList from "../../../../assets/img/icons/ContactList.svg";
import ArrowLine from "../../../../assets/img/icons/ArrowLine.svg";
import DownAngle from "../../../../assets/img/icons/DownAngle.svg";
import Cross from "../../../../assets/img/icons/cross.svg";
import FadeIn from "react-fade-in";
import { addGillRoyIcon } from "utils";

interface AppProps {
  fileName: string;
  handleChangeFile: any;
  inputListName: string;
  fieldsMapping: any;
  setFieldsMapping: any;
  nonMappedFields: string[];
  setNonMappedFields: any;
  handleImportList: any;
  disableImportNowBtn: string;
  setDisableImportNowBtn: any;
  setShowImportListMapAsider: any;
  handleCancelImport?: any;
  errorMessage?: string;
}

const { Option } = Select;

const FloatingPopoverImportMap: React.FC<AppProps> = ({
  fileName,
  handleChangeFile,
  inputListName,
  fieldsMapping,
  setFieldsMapping,
  nonMappedFields,
  setNonMappedFields,
  handleImportList,
  disableImportNowBtn,
  setDisableImportNowBtn,
  setShowImportListMapAsider,
  handleCancelImport,
  errorMessage,
}) => {
  const [message, setMessage] = useState({
    status: false,
    message: "",
    type: "error",
    label: "",
  });
  let serializedMapping = {} as any;
  for (const fieldName in fieldsMapping) {
    if (fieldsMapping[fieldName] == "0") continue;
    serializedMapping[fieldName] = [fieldsMapping[fieldName], fieldName];
  }
  const [mapping, setMapping] = useState(serializedMapping);
  const [nonMappedFieldValues, setNonMappedFieldValues] = useState(nonMappedFields.map(() => "0"));

  const handleSelectChange = (selectedValue: string, fieldName: string) => {
    let newMapping = { ...mapping };
    for (const item in newMapping) {
      if (newMapping[item][1] === selectedValue) newMapping[item][1] = "0";
    }
    newMapping[fieldName][1] = selectedValue;
    setMapping(newMapping);
    let newNonMappedFieldValues = [...nonMappedFieldValues];
    for (let [index, item] of newNonMappedFieldValues.entries()) {
      if (item === selectedValue) newNonMappedFieldValues[index] = "0";
    }
    setNonMappedFieldValues(newNonMappedFieldValues);
  };

  const handleSelectChangeNonMapped = (selectedValue: string, index: number) => {
    let newNonMappedFieldValues = [...nonMappedFieldValues];
    newNonMappedFieldValues[index] = selectedValue;
    setNonMappedFieldValues(newNonMappedFieldValues);
    let newMapping = { ...mapping };
    for (const item in newMapping) {
      if (newMapping[item][1] === selectedValue) newMapping[item][1] = "0";
    }
    setMapping(newMapping);
  };

  const resetMapping = () => {
    let serializedMapping = {} as any;
    for (const fieldName in fieldsMapping) {
      if (fieldsMapping[fieldName] == "0") continue;
      serializedMapping[fieldName] = [fieldsMapping[fieldName], fieldName];
    }
    setMapping(serializedMapping);
    setNonMappedFieldValues(nonMappedFields.map(() => "0"));
  };

  const validateMapping = () => {
    let selectedMapping = [];
    for (const label in mapping) selectedMapping.push(mapping[label][1]);
    let isEmailMapped = selectedMapping.indexOf("email") >= 0 || nonMappedFieldValues.indexOf("email") >= 0;
    if (isEmailMapped) {
      setMessage({
        status: false,
        message: "",
        type: "error",
        label: "",
      });
      let updatedMapping = {} as any;
      for (const label in mapping) {
        if (mapping[label][1] == "0") continue;
        updatedMapping[label] = mapping[label][0];
      }
      for (const [index, label] of nonMappedFieldValues.entries()) {
        if (label == "0") continue;
        updatedMapping[label] = nonMappedFields[index];
      }
      setDisableImportNowBtn("disabled disabled-style");
      handleImportList(updatedMapping);
    } else {
      setMessage({
        status: true,
        message: "You have not selected email for any field. Email mapping is mandatory.",
        type: "error",
        label: "",
      });
    }
  };

  useEffect(() => {
    resetMapping();
    if (Object.values(fieldsMapping).every((item) => item == "0")) {
      setMessage({
        status: true,
        message: "No fields matched, please try again.",
        type: "error",
        label: "Error",
      });
    } else {
      setMessage({
        status: false,
        message: "",
        type: "error",
        label: "",
      });
    }
  }, [fileName, fieldsMapping]);


  const handleCancelImportFunc = () => {
    if (handleCancelImport)
      handleCancelImport()
    else setShowImportListMapAsider(false)
    if (!window.location.pathname.includes("editionedit"))
      addGillRoyIcon()

  }

  return (
    <Wrapper>
      <Row className="first-wrapper">
        <span
          className="cross"
          onClick={handleCancelImportFunc}
        >
          <img src={Cross} alt="" />
        </span>
        <Col span={12}>
          <h2>Import mapping</h2>
        </Col>
        <Col span={12}>
          <div className="d-flex justify-content-end">
            <ButtonOutlineTwo
              title="Reset mapping"
              outlineClass="green-outline"
              green="green"
              onClick={resetMapping}
            />
            <ButtonSmall
              value="Import now"
              green="green"
              onClick={validateMapping}
              className={disableImportNowBtn}
            // className="disabled disabled-style"
            />
          </div>
        </Col>
        <Col span={12}>
          {errorMessage?.length !== 0 && (
            <div className="mt-2">
              <FadeIn>
                <Message type="error" label="Error" message={errorMessage} />
              </FadeIn>
            </div>
          )}
        </Col>
        <Col span={24}>
          <p className="mt-3">
            Before we begin importing, let’s map the fields in your file to our Workbench fields.
            {/* You can also
            select ‘New custom field’ in the dropdown to create your own data points about your contacts and
            companies in Workbench. */}
          </p>
        </Col>
        <Col span={24}>
          {message.message !== "" ? (
            <Message type={message.type} label={message.label} message={message.message} />
          ) : null}
        </Col>
        <Col span={24}>
          <div className="header-import">
            <Row>
              <Col span={12}>
                <div className="d-flex justify-content-between pe-4 me-2">
                  <div className="pe-3 d-flex justify-content-start align-items-start first-col">
                    <img src={ContactList} alt="" />
                    <div className="ps-3 file-name-size">
                      <p className="green">Importing from:</p>
                      <h3>"{fileName}"</h3>
                    </div>
                  </div>
                  <div className="ps-3 min-width" onClick={handleChangeFile}>
                    <span className="change-file">Change file</span>
                  </div>
                </div>
              </Col>
              <Col span={12} className="ps-5">
                <p className="green">Importing to:</p>
                <h3>{inputListName}</h3>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={24}>
          <Row className="pt-4">
            <Col span={12} className="d-flex justify-content-center">
              <label className="sub-label">Your file:</label>
              <label className="sub-label text-left">Fields in xiQ:</label>
            </Col>
            <Col span={12} className="d-flex justify-content-center">
              <label className="sub-label">Your file:</label>
              <label className="sub-label text-left">Fields in xiQ:</label>
            </Col>
            {Object.keys(mapping).map((key, index) => (
              <Col key={index} span={12} className="d-flex justify-content-center align-items-center my-1">
                <label className="label">
                  {mapping[key][0]}
                  <img src={ArrowLine} />
                </label>
                <Select
                  defaultValue={key}
                  value={mapping[key][1]}
                  onChange={(selectedValue) => handleSelectChange(selectedValue, key)}
                  className="select-dropdown"
                >
                  <Option value="0">--</Option>
                  <Option value="first_name">First name</Option>
                  <Option value="last_name">Last name</Option>
                  <Option value="email">Email</Option>
                  <Option value="designation">Designation</Option>
                  <Option value="company_name">Company Name</Option>
                  <Option value="company_website">Company Website</Option>
                  <Option value="phone_number">Phone Number</Option>
                  <Option value="industry">Industry</Option>
                  <Option value="linkedin_url">Linkedin Url</Option>
                </Select>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
      {nonMappedFields?.length > 0 ? (
        <Row className="last-wrapper">
          {nonMappedFields.map((fieldName, index) => (
            <Col key={index} span={12} className="d-flex justify-content-center align-items-center my-1">
              <label className="label" title={fieldName}>
                {fieldName}
                <img src={ArrowLine} />
              </label>
              <Select
                defaultValue="0"
                value={nonMappedFieldValues[index]}
                onChange={(selectedValue: string) => handleSelectChangeNonMapped(selectedValue, index)}
                className="select-dropdown"
              >
                <Option value="0">--</Option>
                <Option value="first_name">First name</Option>
                <Option value="last_name">Last name</Option>
                <Option value="email">Email</Option>
                <Option value="designation">Designation</Option>
                <Option value="company_name">Company Name</Option>
                <Option value="company_website">Company Website</Option>
                <Option value="phone_number">Phone Number</Option>
                <Option value="industry">Industry</Option>
                <Option value="linkedin_url">Linkedin Url</Option>
              </Select>
            </Col>
          ))}
        </Row>
      ) : null}
    </Wrapper>
  );
};

export default FloatingPopoverImportMap;

const Wrapper = styled.div`
  max-width: 970px;
  max-height: calc(100vh - 100px);
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #001760 #efefef;
  .min-width {
    min-width: 96px;
    padding-top: 12px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding-top: 0px;
    }
  }
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    border-radius: 5px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: #fff;
    margin-top: 10px;
    margin-bottom: 15px;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #001760;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #efefef;
  }
  .last-wrapper {
    background-color: #f8f8f8;
    padding: 35px 60px 35px 60px;
    border-radius: 0 0 15px 15px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 20px 35px;
    }
  }
  .first-wrapper {
    padding: 60px 60px 30px 60px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 25px 35px;
    }
  }
  .first-wrapper,
  .last-wrapper {
    h2 {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 28px !important;
        line-height: 28px !important;
      }
    }
    .wrapper[green="green"] {
      border-radius: 8px;
      margin-right: 10px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 5px;
      }
      p {
        font-family: "Roboto", sans-serif;
      }
    }
    .header-import {
      background: #e9fff0;
      border-radius: 8px;
      padding: 20px 24px 15px 24px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 6px;
      }
      .first-col {
        overflow: hidden;
        max-width: calc(100% - 95px);
        .file-name-size {
          max-width: 245px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            max-width: 135px;
          }
          h3 {
            width: calc(100% - 220px);
            min-width: 100%;
          }
        }
      }
      img {
        max-width: 32px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          max-width: 22px;
        }
      }
      .green {
        margin: 0;
        color: #27ce0a;
        font-size: 12px;
        font-weight: 500;
        font-family: "Roboto", sans-serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 8px;
        }
      }
      h3 {
        font-family: "Roboto", sans-serif;
        color: #424b50;
        font-size: 16px;
        font-size: 700;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-word;
        overflow: hidden;
        max-width: 100%;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
      }
      .change-file {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: 700;
        font-size: 10px;
        color: #27ce0a;
        border: 1px solid #27ce0a;
        padding: 5px 12px;
        border-radius: 6px;
        cursor: pointer;
        white-space: nowrap;
        word-break: keep-all;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 4px;
          font-size: 8px;
          padding: 3px 8px;
          margin-top: 5px;
          float: left;
        }
      }
    }
    label {
      font-family: "Roboto", sans-serif;
      min-width: 165px;
      text-align: right;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        min-width: 135px;
      }
      &.sub-label {
        color: #5e7079;
        font-weight: 400;
        font-size: 14px;
        font-family: "Roboto", sans-serif;
        margin: 0 37px;
        min-width: 55px;
        text-align: right;
        margin-bottom: 10px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
          min-width: 90px;
        }
        &.text-left {
          text-align: left;
          min-width: 225px;
          margin: 0;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            min-width: 160px;
          }
        }
      }
      &.label {
        color: #424b50;
        font-weight: 700;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        white-space: nowrap;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 11px;
        }
        img {
          max-width: 25px;
          margin: 0 5px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            max-width: 18px;
          }
        }
      }
    }
    .select-dropdown {
      .ant-select-selector {
        border: 1px solid #dadada;
        border-radius: 8px;
        background-color: #fff;
        color: #7e7e7e;
        font-family: "Roboto", sans-serif;
        font-size: 16px;
        font-weight: 500;
        padding: 5px 13px;
        min-width: 225px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          min-width: 160px;
          border-radius: 6px;
          padding: 5px 10px;
          font-size: 11px;
          height: 28px;
        }
      }
      .ant-select-arrow {
        background-image: url(${DownAngle});
        background-repeat: no-repeat;
        background-position: 8px 8px;
        border-left: 1px solid #dddddd;
        padding-left: 10px;
        margin-left: 10px;
        min-width: 22px;
        min-height: 22px;
        vertical-align: 0;
        top: 40%;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          min-height: 18px;
          height: 18px;
          top: 10px;
        }
        span {
          opacity: 0;
        }
      }
    }
    .cross {
      cursor: pointer;
      position: absolute;
      top: 0px;
      right: 20px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        top: -10px;
        right: 10px;
      }
    }
    .cross > img {
      width: auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 25px;
      }
    }
  }
`;
